export default {
    init() {
        
        //alert ('dashboard init');
        // JavaScript to be fired on the about us page

        /*-----------------------------------------------------------------------------------------------------*/
        // prep – differentiate response for select or div containers
        /*-----------------------------------------------------------------------------------------------------*/

        //alert ('fu');

        var oTheContainer = $('.dashboard-data-container');

        if ( $(oTheContainer).is('div') )
        {
            oTheContainer.append(window.sTheLoader);
        }

        /*-----------------------------------------------------------------------------------------------------*/
        // do ajax
        /*-----------------------------------------------------------------------------------------------------*/

        window.Ajax.getPosts (
        {
            site: $(oTheContainer).attr('data-site'),
            page: $(oTheContainer).attr('data-page'),
        },
        function (data)
        {

            console.log(data);

            if ($('.prime-loader').length > 0)
            {
                $('.prime-loader').remove();
            }

            window.oThePrologue = '<span class="-is-hidden">Success</span>';
            oTheContainer.html(window.oThePrologue + data.markup); // TODO solve for filter
            $(oTheContainer).prop('disabled', false).removeProp('disabled');
            window.doResize();
        },
        function (data)
        {
            window.showError(data);
        });

        $(document).on('click', 'button.import', function(e)
        {
            e.preventDefault();

            var $this = $(this);
            var $oTheContainer = $(this).closest('td');
            $this.prop('disabled', 'disabled');

            window.Ajax.importPosts (
            {
                id: $this.attr('data-id'),
                site: $this.attr('data-site-id'),
                url: $this.attr('data-site-url')},

                function (data)
                {
                    alert('Import complete!');
                    $this.remove();

                    $oTheContainer.html(data.markup);
                    //$oTheContainer.closest('main').append(data.markup);


                },
                function ()
                {
                    alert('Det oppsto en feil');
                }
            );
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/dashboard.js